import React from "react";
import { useTheme } from "../../context/ThemeContext";

export default function LogoWordmark({ onClick }) {
  const { t } = useTheme();
  return (
    <div onClick={onClick} style={{ display: "flex", alignItems: "center", gap: 9, cursor: "pointer" }}>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <rect x="1" y="1" width="9" height="9" rx="2" fill={t.text} />
        <rect x="12" y="1" width="9" height="9" rx="2" fill={t.text} opacity="0.3" />
        <rect x="1" y="12" width="9" height="9" rx="2" fill={t.text} opacity="0.3" />
        <rect x="12" y="12" width="9" height="9" rx="2" fill={t.text} />
      </svg>
      <span style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 17, fontWeight: 700, letterSpacing: "-0.01em", color: t.text }}>
        QuantSoc
      </span>
    </div>
  );
}
